import { SearchAddress } from "components/AutoAddress/api/addressApi";

export const EMPTY_ADDRESS_VALUE: SearchAddress = {
  id: "",
  AddressLine: "",
  Country: "",
  CountryCode: "",
  Locality: "",
  Postcode: "",
  RecordId: "",
  State: "",
} as const;
